export default "__VITE_PUBLIC_ASSET__79952e11__"